import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { fetchPatient } from 'actions/action-patient';
import { useDispatch } from 'react-redux';
import { styles } from '../nav-styles';
import NewPatientTasks from '../../../containers/patient/tasks-new/index';

const Tasks = ({ match }) => {
  const { patientId } = match.params;
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(fetchPatient(patientId));
  }, []);

  return (
    <div>
      <NewPatientTasks patientId={patientId} />
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(Tasks);
